import React, { useState, useEffect } from 'react';
import { 
  Form, Input, Button, Card, Typography, Layout, 
  message, Space, Divider
} from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';

const { Title, Text } = Typography;
const { Content } = Layout;

const LoginPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  // 检查是否已登录
  useEffect(() => {
    if (authAPI.isLoggedIn()) {
      navigate('/');
    }
  }, [navigate]);
  
  // 处理登录
  const handleLogin = async (values) => {
    try {
      setLoading(true);
      const { password } = values;
      
      const response = await authAPI.login(password);
      
      if (response.success) {
        // 保存令牌到本地存储
        localStorage.setItem('auth_token', response.data.token);
        
        message.success('登录成功');
        navigate('/');
      } else {
        message.error('登录失败: ' + response.message);
      }
    } catch (error) {
      console.error('登录失败:', error);
      message.error('登录失败: ' + (error.message || '密码错误'));
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Content style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        padding: '50px 0'
      }}>
        <Card style={{ width: 400, boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <Title level={2} style={{ marginBottom: 8 }}>工作流管理系统</Title>
            <Text type="secondary">请输入系统访问密码</Text>
          </div>
          
          <Divider />
          
          <Form
            form={form}
            layout="vertical"
            onFinish={handleLogin}
          >
            <Form.Item
              name="password"
              rules={[
                { required: true, message: '请输入密码' }
              ]}
            >
              <Input.Password 
                prefix={<LockOutlined />}
                placeholder="请输入系统密码" 
                size="large"
              />
            </Form.Item>
            
            <Form.Item>
              <Button 
                type="primary" 
                htmlType="submit" 
                loading={loading}
                size="large"
                block
              >
                登录系统
              </Button>
            </Form.Item>
          </Form>
          
          <div style={{ textAlign: 'center', marginTop: 16 }}>
            <Text type="secondary">
              系统仅限授权人员访问
            </Text>
          </div>
        </Card>
      </Content>
    </Layout>
  );
};

export default LoginPage; 